export const APP_TRANSLATION_LANGUAGES = ['ko'];
export const APP_TRANSLATION_KEY_PREFIX = 'i18n.';
export const APP_TRANSLATION_MAX_LENGTH = 500;
export const APP_TRANSLATION_MIN_BUILD = 179142502;
const CONTROL_CHARACTERS_EXCEPT_NEWLINE = /[\u0000-\u0009\u000B-\u001F\u007F]/;
const PLACEHOLDER_PATTERN = /{{\s*-?\s*([^\s,}]+)[^}]*}}|\$t\(([^)]*)\)/g;
function isAppTranslationLanguage(value) {
    return APP_TRANSLATION_LANGUAGES.includes(value);
}
export function toAppTranslationSettingKey(language, translationKey) {
    return `${APP_TRANSLATION_KEY_PREFIX}${language}.${translationKey}`;
}
export function parseAppTranslationSettingKey(key) {
    if (!key.startsWith(APP_TRANSLATION_KEY_PREFIX))
        return null;
    const rest = key.slice(APP_TRANSLATION_KEY_PREFIX.length);
    const dot = rest.indexOf('.');
    if (dot <= 0)
        return null;
    const language = rest.slice(0, dot);
    const translationKey = rest.slice(dot + 1);
    if (!isAppTranslationLanguage(language) || translationKey === '')
        return null;
    return { language, translationKey };
}
export function extractTranslationPlaceholders(text) {
    const found = new Set();
    for (const match of text.matchAll(PLACEHOLDER_PATTERN)) {
        found.add(match[1] === undefined ? `$t(${match[2] ?? ''})` : `{{${match[1]}}}`);
    }
    return [...found];
}
export function isWellFormedAppTranslationValue(value) {
    return (typeof value === 'string' &&
        value.length <= APP_TRANSLATION_MAX_LENGTH &&
        value === value.trim() &&
        !CONTROL_CHARACTERS_EXCEPT_NEWLINE.test(value));
}
export function isValidAppTranslationValue(value, bundledText) {
    if (!isWellFormedAppTranslationValue(value))
        return false;
    if (value === '')
        return true;
    const allowed = new Set(extractTranslationPlaceholders(bundledText));
    return extractTranslationPlaceholders(value).every((placeholder) => allowed.has(placeholder));
}
export function flattenTranslations(tree, prefix = '') {
    const result = new Map();
    if (typeof tree !== 'object' || tree === null || Array.isArray(tree))
        return result;
    for (const [name, value] of Object.entries(tree)) {
        const path = prefix === '' ? name : `${prefix}.${name}`;
        if (typeof value === 'string')
            result.set(path, value);
        else
            for (const [inner, text] of flattenTranslations(value, path))
                result.set(inner, text);
    }
    return result;
}
//# sourceMappingURL=translation.js.map